import featuresStore from "../stores/features/featuresStore";
import { API_HOST, PROXY_HOST } from "./environment";

type EndpointType = "orders" | "invoices" | "features" | "deliveryWindows" | "notification_profiles";
export const getBaseUrl = (endpoint: EndpointType): string => {
   const featureMap: Record<EndpointType, boolean> = {
      orders: featuresStore.apiProxyOrders,
      invoices: featuresStore.apiProxyInvoices,
      features: featuresStore.apiProxyFeatures,
      deliveryWindows: featuresStore.apiProxyDeliveryWindows,
      notification_profiles: featuresStore.apiProxyNotificationProfiles
   };

   const base = featureMap[endpoint] ? PROXY_HOST : API_HOST;
   if (!base) {
      throw new Error(`Missing base URL for ${endpoint}. Check API_HOST/PROXY_HOST and environment setup.`);
   }
   return base;
};
